import React from 'react';
import Crown from '../../../icons/subscription_crown.svg';
import {Content} from './styles';
const PackageTitle = ({isMargin, title, subtitle, titleIcon}) => (
  <Content isMargin={isMargin}>
    <div>
      <h3>{title}</h3>
      {titleIcon ? <img src={Crown} alt="crown icon" /> : null}
    </div>
    <p>{subtitle}</p>
  </Content>
);

export default PackageTitle;
